import React from "react";

import closeIcon from "../../Images/close-icon.svg";
import { MAX_COUNTER_LIMIT } from "../../utils/counterState";

export default function CounterForm({
  activeTab,
  setActiveTab,
  newCounterName,
  setNewCounterName,
  newCounterLimit,
  setNewCounterLimit,
  newCounterDays,
  setNewCounterDays,
  editingCounterId,
  formError,
  clearFormError,
  onSubmit,
  onCancel,
}) {
  const isEditing = Boolean(editingCounterId);

  // -------------------------
  // Goal helper (preview text)
  // -------------------------
  const renderGoalHint = () => {
    const L = parseInt(newCounterLimit, 10);
    const D = parseInt(newCounterDays, 10);

    if (!L || !D || D < 1 || D > L) return null;

    if (L % D !== 0) {
      return (
        <p className="createCounterWrapper__hint warning">
          Limit must divide evenly by days (e.g. 50 ÷ 5 or 33 ÷ 3).
          Adjust the numbers so there is no remainder.
        </p>
      );
    }

    const batch = L / D;

    return (
      <p className="createCounterWrapper__hint">
        Each round = <strong>{batch}</strong> count
        {batch === 1 ? "" : "s"}. Exactly{" "}
        <strong>{D}</strong> rounds to reach {L}.
      </p>
    );
  };

  // -------------------------
  // Handlers
  // -------------------------
  const handleNameChange = (e) => {
    clearFormError();
    setNewCounterName(e.target.value);
  };

  const handleLimitChange = (e) => {
    clearFormError();
    setNewCounterLimit(e.target.value);
  };

  const handleDaysChange = (e) => {
    clearFormError();
    setNewCounterDays(e.target.value);
  };

  // -------------------------
  // Render
  // -------------------------
  return (
    <>
      {/* Overlay */}
      <div className="overlay" onClick={onCancel} />

      {/* Modal */}
      <div
        className="createCounterWrapper show"
        role="dialog"
        aria-modal="true"
        aria-label="Counter form dialog"
      >
        {/* Header */}
        <div className="createCounterWrapper__header">
          <p>
            {isEditing
              ? "Update Counter"
              : "Create New Counter"}
          </p>

          <button
            type="button"
            className="iconButton"
            onClick={onCancel}
            aria-label="Close form"
          >
            <img src={closeIcon} alt="" title="Close" />
          </button>
        </div>

        {/* Body */}
        <div className="createCounterWrapper__body">
          {/* Error */}
          {formError && (
            <p className="form-error">{formError}</p>
          )}

          {/* Tabs (only for create mode) */}
          {!isEditing && (
            <div className="tabs-header">
              <button
                type="button"
                className={`daily ${
                  activeTab === "daily" ? "active" : ""
                }`}
                onClick={() => {
                  clearFormError();
                  setActiveTab("daily");
                }}
              >
                Daily
              </button>

              <button
                type="button"
                className={`goal ${
                  activeTab === "goal" ? "active" : ""
                }`}
                onClick={() => {
                  clearFormError();
                  setActiveTab("goal");
                }}
              >
                Goal
              </button>
            </div>
          )}

          {/* Daily Form */}
          {activeTab === "daily" && (
            <div className="daily">
              <form onSubmit={onSubmit}>
                <label>
                  Counter Name
                  <input
                    type="text"
                    value={newCounterName}
                    onChange={handleNameChange}
                  />
                </label>

                {!isEditing && (
                  <label>
                    Daily count (max 1,25,00,000)
                    <input
                      type="number"
                      min={1}
                      max={MAX_COUNTER_LIMIT}
                      step={1}
                      value={newCounterLimit}
                      onChange={handleLimitChange}
                    />
                  </label>
                )}

                <div className="btnWrapper">
                  <button
                    type="submit"
                    className="confirm"
                  >
                    {isEditing ? "Update" : "Create"}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Goal Form */}
          {activeTab === "goal" && (
            <div className="goal">
              <form onSubmit={onSubmit}>
                <label>
                  Counter Name
                  <input
                    type="text"
                    value={newCounterName}
                    onChange={handleNameChange}
                  />
                </label>

                {!isEditing && (
                  <>
                    <label>
                      Limit (max 1,25,00,000)
                      <input
                        type="number"
                        min={1}
                        max={MAX_COUNTER_LIMIT}
                        step={1}
                        value={newCounterLimit}
                        onChange={handleLimitChange}
                      />
                    </label>

                    <label>
                      Total days (plan length)
                      <input
                        type="number"
                        min={1}
                        max={MAX_COUNTER_LIMIT}
                        step={1}
                        value={newCounterDays}
                        onChange={handleDaysChange}
                      />
                    </label>

                    {renderGoalHint()}
                  </>
                )}

                <div className="btnWrapper">
                  <button
                    type="submit"
                    className="confirm"
                  >
                    {isEditing ? "Update" : "Create"}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}